(function ($) {

    $(document).ready(function () {

        if ($('#timeline-slider').length) {

            var hash = window.location.hash.substring(1),
                post_id = slider_data.slider_data[0]['post_id'];

            if (hash && hash != post_id) {
                post_id = window.location.hash.substring(1);
            } else {
                load_timeline_post(post_id);
            }

            new Vue({
                el: '#timeline-slider',
                data: {
                    slides: 0
                },
                created: function () {
                    setTimeout(function () {
                        $('#timeline-slider .carousel-3d-slide[data-id="' + post_id + '"]').click();
                    }, 100);
                },
                methods: {
                    onAfterSlideChange(index) {
                        load_timeline_post($('#timeline-slider .carousel-3d-slide:eq(' + index + ')').data('id'));
                    }
                },
                components: {
                    'carousel-3d': Carousel3d.Carousel3d,
                    'slide': Carousel3d.Slide
                },

                mounted: function () {
                    let self = this;

                    self.slides = slider_data.slider_data;

                }
            });


            function load_timeline_post(post_id) {
                var ajaxurl = ajaxMeta.ajaxurl;

                $.ajax({
                    url: ajaxurl,
                    type: 'post',
                    data: {
                        action: 'load_timeline_post',
                        'post_id': post_id
                    },
                    success: function (data) {
                        var $data = $(data);

                        if ($data.length) {
                            $('.future_for_health-posts .container').empty().append($data).find('.single-post').fadeIn('slow');

                            loadDisqus();

                            window.vc_js();

                            setTimeout(function () {
                                $(window).trigger('resize');
                            }, 1000);


                            var Identifier = $('.single-post').data('post-identifier'),
                                Url = $('.single-post').data('post-url'),
                                Title = $('.single-post').data('post-title');

                            setTimeout(function () {
                                resetDisqus(Identifier, Url, Title);
                            }, 1000);

                            addthis.toolbox('.addthis_toolbox');

                            window.location.hash = post_id;
                        } else {
                            console.log('error');
                        }
                    }
                });
            }


        }

    });


    function loadDisqus() {
        /* * * CONFIGURATION VARIABLES: EDIT BEFORE PASTING INTO YOUR WEBPAGE * * */
        var disqus_shortname = countVars.disqusShortname;

        /* * * DON'T EDIT BELOW THIS LINE * * */
        (function () {
            var dsq = document.createElement('script');
            dsq.type = 'text/javascript';
            dsq.async = true;
            dsq.id = "dsq_js";
            dsq.src = 'https://' + disqus_shortname + '.disqus.com/embed.js';
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(dsq);
        })();
    }

    function resetDisqus(newIdentifier, newUrl, newTitle) {
        //console.log(newIdentifier, newUrl, newTitle);

        if (typeof DISQUS != 'undefined') {
            DISQUS.reset({
                reload: true,
                config: function () {
                    this.page.identifier = newIdentifier;
                    this.page.url = newUrl;
                    this.page.title = newTitle;
                }
            });
        } else {
            $('#disqus_thread').live('load', function () {
                DISQUS.reset({
                    reload: true,
                    config: function () {
                        this.page.identifier = newIdentifier;
                        this.page.url = newUrl;
                        this.page.title = newTitle;
                    }
                });
            });
        }
    }

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/timeline.es6